var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareScreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.19 21.64V19.48H14.41C16.82 19.48 19.23 19.48 21.64 19.48C21.8 19.48 21.88 19.4 21.88 19.24C21.88 14.33 21.88 9.41 21.88 4.5C21.88 4.44 21.88 4.37 21.88 4.31C21.88 4.22 21.85 4.17 21.75 4.18C21.71 4.18 21.67 4.18 21.63 4.18C15.24 4.18 8.84 4.18 2.45 4.18C2.27667 4.18 2.19 4.26667 2.19 4.44C2.19 5.35 2.19 6.26 2.19 7.18C2.19 7.25 2.19 7.32 2.19 7.39H0C0 7.32 0 7.26 0 7.2C0 6.22 0 5.24 0 4.25C0 3.09 0.71 2.24 1.85 2.03C1.99 2 2.14 2 2.28 2C8.75 2 15.22 2 21.69 2C22.65 2 23.36 2.39 23.79 3.25C23.94 3.55 24 3.89 24 4.22C24 9.28 24 14.35 24 19.41C24 20.54 23.2 21.45 22.08 21.62C22 21.63 21.92 21.62 21.84 21.62C19.35 21.62 16.86 21.62 14.37 21.62C14.32 21.62 14.27 21.62 14.2 21.62L14.19 21.64Z",
    fill: "#0A3B87"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.55 21.59C10.49 18.7 9.48001 16.2 7.44001 14.16C5.40001 12.12 2.90001 11.13 0.0100098 11.07V8.76999C6.93001 8.62999 12.97 14.6 12.84 21.59H10.55Z",
    fill: "#0A3B87"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.89001 21.6199C5.85001 20.0099 5.28001 18.6199 4.14001 17.4899C3.01001 16.3599 1.61001 15.7999 0.0100098 15.7599V13.4399C2.11001 13.4699 3.93001 14.1699 5.49001 15.5699C7.48001 17.3499 8.24001 19.8399 8.19001 21.6199H5.89001Z",
    fill: "#0A3B87"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 21.59V18.18C1.53 17.83 3.66 19.94 3.45 21.59H0Z",
    fill: "#0A3B87"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.33 5.41003H3.82001V7.40003C8.19001 7.53003 14.23 12.51 14.22 18.38H20.48V6.56003C20.48 5.92003 19.97 5.41003 19.33 5.41003Z",
    fill: "#F28629"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareScreen);
export default __webpack_public_path__ + "static/media/share-screen.e44e7b5b19f35402725f09d89c480565.svg";
export { ForwardRef as ReactComponent };